// useApi2Resource.js
//
// Loads one api2 resource and holds { data, loading, error }. The loader is
// passed in rather than a URL so the caller chooses which helper in
// utils/parties it goes through, and passing null skips the request entirely
// (a party page with no state has no state party to ask for).
//
// Late answers are ignored rather than aborted: the helpers share cached
// promises between components, so cancelling one consumer's copy would cancel
// everyone's. See the note at the top of utils/parties.

import { useEffect, useState } from 'react';

const IDLE = { data: null, loading: false, error: null };
const LOADING = { data: null, loading: true, error: null };

export default function useApi2Resource(loader, deps) {
  const [state, setState] = useState(loader ? LOADING : IDLE);

  useEffect(() => {
    if (!loader) {
      setState(IDLE);
      return undefined;
    }

    let live = true;
    setState(LOADING);

    loader()
      .then((data) => {
        if (live) setState({ data, loading: false, error: null });
      })
      .catch((error) => {
        if (live) setState({ data: null, loading: false, error });
      });

    return () => {
      live = false;
    };
    // The loader is a fresh closure every render; deps says when it changed.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return state;
}